var _style, _defs, _path, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnavailableUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.6 16.7",
    style: {
      enableBackground: "new 0 0 16.6 16.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000168808995389292326210000001135300664928778169_);}\n\t.st1{fill:#E04167;}\n\t.st2{fill:#F9E0E6;stroke:#F9E0E6;stroke-width:0.9619;}\n\t.st3{fill:#E04167;stroke:#E04167;stroke-width:0.904;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -0.9,
    y: -1.3,
    width: 18,
    height: 18
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000156565847913456192660000005320856861451631018_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000156565847913456192660000005320856861451631018_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.4,4.3c0-2.1,1.7-3.7,3.8-3.7c2.1,0,3.8,1.7,3.8,3.7S10.2,8,8.1,8C6.1,8,4.4,6.3,4.4,4.3z M11.2,8.8 c-0.4-0.1-0.9,0-1.3,0.2C8.8,9.6,7.4,9.6,6.3,9C5.9,8.8,5.5,8.7,5,8.8c-1.5,0.4-2.5,1.7-2.5,3.3v0.8c0,0.5,0.1,0.9,0.4,1.4 c0.2,0.3,0.6,0.5,1,0.5h8.6c0.4,0,0.8-0.2,1-0.5c0.2-0.4,0.4-0.9,0.4-1.4v-0.8C13.8,10.6,12.7,9.2,11.2,8.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.1,
    y: 7.4,
    transform: "matrix(0.6745 -0.7383 0.7383 0.6745 -3.2335 8.3546)",
    className: "st2",
    width: 18,
    height: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.1,15.1L14.7,2.5c0.2-0.2,0.5-0.2,0.6,0l0,0c0.2,0.2,0.2,0.5,0,0.6L3.8,15.7c-0.2,0.2-0.5,0.2-0.6,0l0,0 C3,15.6,3,15.3,3.1,15.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailableUser);
export default __webpack_public_path__ + "static/media/unavailable-user.2c62c3ceb437a5cf0cf8c9de2724f6ca.svg";
export { ForwardRef as ReactComponent };